// Only the requested place: its code and initial static requests begin
// while the map starts. Runtimes consume them without starting live polls.

import type { ApiClient } from '@tol/core/feed';
import { primeJSON } from '@tol/gtfs/poll';
import type { Region } from './regions.ts';

export async function primeRegion(region: Region | undefined, getJSON: ApiClient['getJSON']): Promise<void> {
  if (!region) return;
  try {
    if (region.kind === 'london') {
      const { primeLondon } = await import('./london-region.ts');
      primeLondon(region, getJSON);
    } else {
      const page = await region.code();
      if (region.partitioned === true) primeJSON(`${region.path}network-parts.json`);
      else {
        // Buses come later, as in gtfs-region.ts.
        const suffix = page.lines.some((l) => l.minor === true) ? '-major' : '';
        primeJSON(`${region.path}network${suffix}.json`);
        primeJSON(`${region.path}geometry${suffix}.json`);
      }
    }
  } catch {
    // Failed code imports are retried when the map asks for the region.
  }
}
